import { createRouter, createWebHistory } from 'vue-router'
import Index from '../views/Index.vue'

const routes = [
  {
    path: '/referral',
    name: 'index',
    component: Index
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
